import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/gongan.png';

const _withScopeId = n => (_pushScopeId("data-v-5ffa451c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-bottom"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "粤ICP备2021101066号")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("p", null, "Copyright©2021-" + _toDisplayString(new Date().getFullYear()) + " 广州森吉物流有限公司", 1), _hoisted_2]);
}